import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const SubscriptionCQGInfoModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.CQG Integrated Client')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <p className='mb-2'>
            {t('Subscriptions.CQGs Flagship Product - accurate global market data')}
          </p>
          <p>
            <Trans i18nKey='Subscriptions.Additional fees may apply. For more Information on CQG Integrated client pricing'>
              Additional fees may apply. For more Information on CQG Integrated client pricing and
              options or features click
              <a
                href='https://www.cqg.com/products/cqg-integrated-client'
                target='_blank'
                rel='noreferrer'
              >
                here
              </a>
              or
              <a
                href='https://partners.cqg.com/marketing-resources/monthly-price-sheet'
                target='_blank'
                rel='noreferrer'
              >
                here
              </a>
              .
            </Trans>
          </p>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got it!')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
